import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Game from '../components/Game/Game'
import { useGame } from '../contexts/GameContext'
import { useWebSocket } from '../contexts/WebSocketContext'

export default function GamePage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { getGame, setCurrentGame, currentGame } = useGame()
  const { isConnected, joinGame: joinWebSocketGame } = useWebSocket()
  const [sessionWins, setSessionWins] = useState({})
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadGame = async () => {
      // If we're navigating to a new game, clear the old one immediately 
      // to render the loading state instead of the stale game
      if (id && currentGame?.id && currentGame?.id !== id) {
        setCurrentGame(null)
      }

      if (!id) return

      try {
        // If we already have the correct game loaded, don't re-fetch needlessly
        if (currentGame?.id === id) {
             if (isConnected) {
                joinWebSocketGame(id)
             }
             return
        }

        const game = await getGame(id)
        setCurrentGame(game)
        
        if (isConnected) {
          joinWebSocketGame(id)
        }
      } catch (err) {
        console.error('Failed to load game:', err)
        setError('Failed to load game')
      }
    }

    loadGame()
  }, [id, isConnected, getGame, setCurrentGame, joinWebSocketGame, currentGame?.id])

  if (error) {
    return <div className="game-load-error">Error: {error} <button onClick={() => navigate('/')}>Go Home</button></div>
  }
  
  // While loading or if id doesn't match yet, we might show a loader
  // But Game component handles some loading states too. 
  // We'll pass the ID we intend to show.
  
  return (
    <Game
        gameId={id}
        onBack={() => navigate('/')}
        onViewReplay={(gameId, moveNumber) => navigate(`/replay/${gameId}/${moveNumber}`)}
        onNavigateToGame={(newGameId) => navigate(`/game/${newGameId}`)}
        sessionWins={sessionWins}
        onUpdateSessionWins={setSessionWins}
    />
  )
}
